<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    @if (task === 'Edit') {
      {{screenName}} ({{ workOrderNumber }})
    } @else {
      {{screenName}}
    }
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="bolForm">
    <div class="shipping-grid">
      <!-- LEFT COLUMN -->
      <div class="form-grid-row">
        <!-- @if(isDriverMode && inputType == 'Inbound'){ -->
          <div class="outbound-popup">
            <app-select-search formControlName="status"
              [selectItems]="selectStatusItems" selectTitle="Status"  (selectedItemId)="onStatusreceived($event)"></app-select-search>
          </div>
          <br />
        <!-- } -->
        <!-- Ship From -->
        <div class="outbound-popup">
          <app-select-search formControlName="shipFromId" (selectedItemId)="onShipFromReceived($event)"
            [isrequired]="true" [matcher]="matcher" [setId]="shipFromId"
            [invalid]="!!(bolForm.get('shipFromId')?.invalid && (bolForm.get('shipFromId')?.touched || attemptSave()))"
            [selectItems]="shipFrom" selectTitle="Ship From"></app-select-search>
        </div>
        <div class="card">
          <div class="address">
            {{shipFromLoc}}
          </div>
        </div>
        @if(isDriverMode && inputType == 'Inbound'){
          <br />
          <div class="outbound-popup">
            <app-select-search formControlName="locationId"
              [isrequired]="true" [matcher]="matcher"
              [invalid]="!!(bolForm.get('locationId')?.invalid && (bolForm.get('locationId')?.touched || attemptSave()))"
              [selectItems]="locations" selectTitle="Locations"></app-select-search>
          </div>
        }
        <br  />
        <!-- Ship To -->
         <div class="outbound-popup">
            <app-select-search formControlName="shipToId" (selectedItemId)="onShipToReceived($event)"
              [isrequired]="true" [matcher]="matcher" [setId]="shipToId"
              [invalid]="!!(bolForm.get('shipToId')?.invalid && (bolForm.get('shipToId')?.touched || attemptSave()))"
              [selectItems]="shipTo" selectTitle = "Ship To"></app-select-search>
          </div>
        <div class="card">
          <div class="address">
            {{shipToLoc}}
          </div>
        </div>
        <br  />
        
        <mat-form-field appearance="outline" class="flex-50 large" style="width:100%">
          <mat-label>Notes</mat-label>
          <textarea matInput maxlength="250" formControlName="internalNotes"
            data-testid="internalNotes" name="internalNotes" rows="3"></textarea>
        </mat-form-field>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="form-grid-row">
        <mat-form-field appearance="outline">
          <mat-label>Date Received</mat-label>
          <input data-testid="date" #dateInput id="date" required matInput [matDatepicker]="datePicker"
            formControlName="date" name="date"  (blur)="dateformat($event)" (keydown)="onKeydown($event)"/>
          <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bill of Lading No:</mat-label>
          <input matInput data-testid="bol" type="text" formControlName="bol" name="bol" style="width: 100%"/>
        </mat-form-field>
        
        
        <mat-form-field appearance="outline">
          <mat-label>Work Order #:</mat-label>
          <input matInput data-testid="workOrderNo" type="text" formControlName="workOrderNo" name="workOrderNo"/>
        </mat-form-field>
        <div class="note">
          A WORK ORDER NUMBER MUST BE REFERENCED ON INVOICES TO RECEIVE
          TIMELY PAYMENT IF APPLICABLE.
        </div>

        <div class="outbound-popup">  
          <app-select-search formControlName="carrierId"
            [isrequired]="true" [matcher]="matcher"
            [invalid]="!!(bolForm.get('shipToId')?.invalid && (bolForm.get('shipToId')?.touched || attemptSave()))"
            (selectedItemId)="onCarrierReceived($event)" [selectItems]="haulerList" selectTitle = "Carrier Name">
          </app-select-search>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Driver Name:</mat-label>
          <input matInput type="text" formControlName="driver" data-testid="driver" name="driver" maxlength="50"/>
        </mat-form-field>  
        
        <mat-form-field appearance="outline">
          <mat-label>Truck No:</mat-label>
          <input matInput type="text" formControlName="truckNo" data-testid="truckNo" name="truckNo" maxlength="50"/>
        </mat-form-field>      
        
        <mat-form-field appearance="outline">
          <mat-label>Trailer No:</mat-label>
          <input matInput data-testid="trailerNo" type="text" formControlName="trailerNo" name="trailerNo" maxlength="25"/>
        </mat-form-field>      
        
        <mat-form-field appearance="outline">
          <mat-label>Tanker No:</mat-label>
          <input matInput data-testid="tankerNo" type="text" formControlName="tankerNo" name="trailerNo" maxlength="25"/>
        </mat-form-field>
      
        
        <mat-form-field appearance="outline">
          <mat-label>Purchase Order #:</mat-label>
          <input matInput data-testid="purchaseOrderNo" type="text" formControlName="purchaseOrderNo" name="purchaseOrderNo" maxlength="25"/>
        </mat-form-field>
        
          
        <mat-form-field appearance="outline">
          <mat-label>Seal #:</mat-label>
          <input matInput data-testid="sealNo" type="text" formControlName="sealNo" name="sealNo" maxlength="25"/>
        </mat-form-field>
      
        
        <mat-form-field appearance="outline">
          <mat-label>Release #:</mat-label>
          <input matInput data-testid="releaseNo" type="text" formControlName="releaseNo" name="sealNo" maxlength="25"/>
        </mat-form-field>
      
        
        <mat-form-field appearance="outline">
          <mat-label>Site pH:</mat-label>
          <input matInput data-testid="cbdPh" type="text" formControlName="cbdPh" name="cbdPh" (input)="roundOff($event, 9, 1, 1)" />
        </mat-form-field>
      </div>
    </div>
    <br />
    <div *ngIf="inputType == 'Outbound'">
      <div class="" style="margin-bottom: 10px;">
        <button mat-raised-button color="primary" data-testid="btnaddStream" (click)="openAddStreamPopup('Add', null)">
          <mat-icon>add</mat-icon> Add Item
        </button>
      </div>
      <div class="mat-elevation-z2 viewport">
        <table mat-table [dataSource]="additionalStreamsDataSource">
          <ng-container matColumnDef="streamName">
            <th mat-header-cell *matHeaderCellDef> Stream Name </th>
            <td mat-cell *matCellDef="let element"> {{element.streamName}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="quantity">
            <th mat-header-cell *matHeaderCellDef> Qty </th>
            <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="uOMText">
            <th mat-header-cell *matHeaderCellDef> Qty. UOM </th>
            <td mat-cell *matCellDef="let element"> {{element.uOMText}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="cBD_WT">
            <th mat-header-cell *matHeaderCellDef> Site WT. </th>
            <td mat-cell *matCellDef="let element"> {{element.cBD_WT}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="cbdUOMText">
            <th mat-header-cell *matHeaderCellDef> Site. UOM </th>
            <td mat-cell *matCellDef="let element"> {{element.cbdUOMText}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="cUST_WT">
            <th mat-header-cell *matHeaderCellDef> Cust WT. </th>
            <td mat-cell *matCellDef="let element"> {{element.cUST_WT}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="custUOMText">
            <th mat-header-cell *matHeaderCellDef> Cust. UOM </th>
            <td mat-cell *matCellDef="let element"> {{element.custUOMText}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="tons">
            <th mat-header-cell *matHeaderCellDef> Actual Tons </th>
            <td mat-cell *matCellDef="let element"> {{element.tons}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="unitPrice">
            <th mat-header-cell *matHeaderCellDef> Unit Price </th>
            <td mat-cell *matCellDef="let element"> {{element.unitPrice}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef> Total </th>
            <td mat-cell *matCellDef="let element"> {{element.total}} </td>
            <td mat-footer-cell *matFooterCellDef class="footer-total">
              {{getGrandTotal() | number: '1.2'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions</th>
            <td mat-cell *matCellDef="let row">
              <div style="margin-left: -13px;">
                <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="openAddStreamPopup('Edit', row)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button type="button" color="warn" title="Delete" style="color: red;" (click)="deleteAddtStreams(row)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedAdditionalStreamColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedAdditionalStreamColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedAdditionalStreamColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" style="color: red;text-align: center;font-weight: 500;">No line items found.</td>
          </tr>
        </table>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button data-testid="btnCancel" mat-raised-button color="primary" (click)="onCancel()" mat-primary>
    Cancel
  </button>
  <button data-testid="btnSave" mat-raised-button color="primary" mat-primary type="submit" (click)="save()">
    Save
  </button>
  <button data-testid="btnSave" mat-raised-button color="primary" mat-primary type="submit" (click)="saveandprint()">
    Save & Print
  </button>
</mat-dialog-actions>
